<template>
  <div>
    <p>version: 1.0</p>
    <div class="settings-buttons-collection">
      <app-local-switcher></app-local-switcher>
      <div @click="logout">
        <app-button-rect :text="$t('settings.logout')"></app-button-rect>
      </div>
      <div @click="recordBeaconId">
        <app-button-rect :text="$t('settings.change_beacon_ID')"></app-button-rect>
      </div>
      <div @click="aboutMyDatas">
        <app-button-rect :text="$t('settings.about_my_datas')"></app-button-rect>
      </div>
      <div v-if="!dataDeleted" @click="deleteMyData">
        <app-button-rect :text="$t('settings.delete_my_datas')"></app-button-rect>
      </div>
      <div v-else>
        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
        <p>{{ $t('settings.request_taken') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import LocalSwitcher from '@/components/LocalSwitcher.vue';
import ButtonRect from '../components/ButtonRect.vue';

export default {
  components: {
    'app-local-switcher': LocalSwitcher,
    'app-button-rect': ButtonRect,
  },
  data() {
    return {
      dataDeleted: false,
    };
  },
  methods: {
    logout() {
      this.$store.dispatch('userLogout');
      this.$router.push('/login');
    },
    recordBeaconId() {
      this.$router.push('/beaconid');
    },
    aboutMyDatas() {
      this.$router.push('/aboutmydatas');
    },
    deleteMyData() {
      this.dataDeleted = true;
      setTimeout(() => { this.dataDeleted = false; }, 3000);
    },
  },
};
</script>

<style scoped>
  .settings-buttons-collection {
    padding: 5%;
  }

  .settings-buttons-collection > div {
    margin-bottom: 22px;
  }

  /******************************************************************
  *                      CIRCLE CHECK MARK                          *
  *******************************************************************/

  /* Circle loader with checkmark completed state: by https://codepen.io/scottloway/pen/zqoLyQ */
  .checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: #7ac142;
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
  }

  .checkmark {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: block;
    stroke-width: 2;
    stroke: #fff;
    stroke-miterlimit: 10;
    margin: 10% auto;
    box-shadow: inset 0px 0px 0px #7ac142;
    animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
  }

  .checkmark__check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
  }

  @keyframes stroke {
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes scale {
    0%, 100% {
      transform: scale3d(1, 1, 1);
    }
    50% {
      transform: scale3d(1.5, 1.5, 1);
    }
  }
  @keyframes fill {
    100% {
      box-shadow: inset 0px 0px 0px 30px #7ac142;
    }
  }
</style>
